module.exports = __webpack_public_path__ + "static/media/about-bg-image.78bc15cd.svg";